import uuid from "react-native-uuid";
import { set } from "lodash";

// Internal Imports
import { getCombinedTags } from "../utils/esignUtils";
import {
  UNDO_REDO_STACK_LIMIT,
  DOCUMENT_COMPONENT_TYPES,
} from "../constants/document";
import { DOCUMENT_BLOCKS } from "../components/DocumentV2/constants";
import documentInitialState from "./documentInitialState";

export default (
  state = {
    ...documentInitialState,
    stripePaymentDetails:
      typeof window !== "undefined" &&
      JSON.parse(localStorage.getItem("stripeData"))
        ? JSON.parse(localStorage.getItem("stripeData"))
        : null,
  },
  action,
) => {
  switch (action.type) {
    /*
      ===============================
        Document Functions
      ===============================
      */
    case "UPDATE_DOCUMENT": {
      const document = action.payload;
      const docDetails = {
        id: document.id,
        docNo: document.docNo,
        name: document.name,
      };
      const content = {
        schema_version: "",
        sections: document.sections,
      };
      return { ...state, document: docDetails, content };
    }
    case "UPDATE_DOCUMENT_TYPES":
      return { ...state, documentTypes: action.payload };
    case "UPDATE_DOCUMENT_NO_PAGES":
      return { ...state, totalNumberOfPages: action.payload };
    case "UPDATE_PAGE_BREAK_SCROLL_VIEW":
      return { ...state, pageBreakScrollToView: action.payload };
    case "UPDATE_DOCUMENT_DETAILS_AND_CONTENT": {
      const documentPayload = action.payload;
      return {
        ...state,
        document: documentPayload.docDetails,
        content: documentPayload.content,
        document_order: documentPayload.docIdOrder,
      };
    }
    case "UPDATE_CLAUSE_INFORMATION":
      return { ...state, clauses: action.payload };
    case "UPDATE_PDF_FORM_FIELDS":
      return { ...state, pdfFormFields: action.payload };
    case "UPDATE_FILLABLE_PDF_FLAG":
      return { ...state, isFillablePDF: action.payload };
    case "UPDATE_GSHEET_SECTION": {
      const {
        sectionData,
        sectionID,
        sheet,
        workSheet,
        rangeValue,
        autoTrim,
        firstRowAsHeader,
      } = action.payload;
      return {
        ...state,
        components: {
          ...state.components,
          [sectionID]: {
            ...state.components[sectionID],
            content: {
              ...state.components[sectionID].content,
              data: {
                ...state.components[sectionID].content.data,
                data: sectionData,
              },
              sheet,
              rangeValue,
              autoTrim,
              workSheet,
              connected: true,
              firstRowAsHeader,
            },
          },
        },
      };
    }

    case "BATCH_UPDATE_SECTION_IN_DOCUMENT": {
      const { components: updatedComponents } = state;
      action.payload.forEach(section => {
        updatedComponents[section.id] = {
          ...updatedComponents[section.id],
          content: section,
        };
      });
      return {
        ...state,
        components: updatedComponents,
      };
    }
    case "UPDATE_CLAUSE_OPTIONS_SECTION_IN_DOCUMENT": {
      const { section, value, isDocFormValid } = action.payload;
      const { components, docForm } = state;
      const updatedComponents = {
        ...components,
        [section.id]: {
          ...components[section.id],
          content: section,
        },
      };
      const updatedDocForm = docForm.map(df => {
        if (df.id === section.clauseOptions.id) {
          df.value = value;
        }
        return df;
      });
      return {
        ...state,
        components: updatedComponents,
        docForm: updatedDocForm,
        isDocFormValid,
      };
    }
    case "NUKE_DOCUMENT_CONTENT":
      return { ...state, content: {} };
    case "NUKE_DOCUMENT_DETAILS":
      return { ...state, document: {} };
    case "NUKE_DOCUMENT":
      return {
        ...state,
        layout: [[]],
        components: {},
        document: {},
        componentsCopy: {},
      };
    case "NUKE_DOCUMENT_APPROVALS_DATA":
      return {
        ...state,
        docAnalysis: [],
        docApprovalStatus: [],
        docPendingApprovers: [],
        docAllApprovers: [],
      };
    case "REACTION_ON_ADDING_DEALTABLE_TO_DOCUMENT":
      return {
        ...state,
        document: {
          ...state.document,
          dealTable: action.payload.discount,
        },
        clauses: [],
      };
    case "ACCOUNT_ASSETS":
      return {
        ...state,
        selectedAccount: action.payload.crm_account,
        accountDocs: action.payload.opp_docs,
        accountGlobalDocs: action.payload.global_docs,
      };
    case "TOOLS_VIEW":
      return { ...state, toolsView: action.payload };

    case "DOC_ANALYSIS": {
      let tempStage = state.stage;
      let tempIsLocked = state.isLocked;
      const { docAnalysis, triggeredFrom } = action.payload;
      // If there is no approval required then,
      // move the document from "DRAFT" to "APPROVED" stage
      if (triggeredFrom !== "forApproval" && docAnalysis.length === 0) {
        tempStage = "APPROVED";
        tempIsLocked = true;
      } else {
        tempStage = "DRAFT";
        tempIsLocked = false;
      }
      return {
        ...state,
        document: {
          ...state.document,
          stage: tempStage,
          isLocked: tempIsLocked,
        },
        docAnalysis,
      };
    }

    case "DOC_RESET_ANALYSIS": {
      return {
        ...state,
        docAnalysis: action.payload,
      };
    }

    case "DOC_APPROVAL_STATUS":
      return {
        ...state,
        docApprovalStatus: action.payload.approvalStatusData,
        docPendingApprovers: action.payload.pendingApprovers,
        docAllApprovers: action.payload.allApprovers,
        collaboratorsData: action.payload.collaboratorsData,
        pendingApprovalRequired: action.payload.pendingApprovalRequired,
        // docPendingApprovers constains those approvers whose individual status is 'pending' whereas docAllApprovers contains approvers with all statuses including 'pending'
      };
    // New refactored Reducer code starts here
    case "REACTION_ON_DOCUMENT_PAGE_LOAD": {
      const { documentPayload, approvalsPayload } = action.payload;
      return {
        ...state,
        content: documentPayload.content,
        document: documentPayload.docDetails,
        tables: documentPayload.tablePayload,
        // For Temproary ....
        showWhoHasAccessForRecipients:
          documentPayload.showWhoHasAccessForRecipients,
        // end..
        document_order: documentPayload.docIdOrder,
        clauses: [],
        docStatusConfigs: documentPayload.docStatusConfigs,
        // Approvals data
        docApprovalStatus: approvalsPayload.approvalStatusData,
        docPendingApprovers: approvalsPayload.pendingApprovers,
        docAllApprovers: approvalsPayload.allApprovers,
        collaboratorsData: action.payload.collaboratorsData,
        pendingApprovalRequired: action.payload.pendingApprovalRequired,
        signatureIFrameURL: action.payload.signatureIFrameURL,
        showIframeView: action.payload.showIframeView,
        signatureEnvelopeID: action.payload.signatureEnvelopeID,
        docForm: action.payload.formFieldPayload,
        hasQuoteTableWrapper: documentPayload.hasQuoteTableWrapper,
        showDocumentDiffView: false,
        sectionTrigger: null,
        docRecipientList: documentPayload.docRecipients,
        acceptorsList: documentPayload.acceptorsList,
        clickedActiveComponentId: null,
        connectedGSheetSections: action.payload.connectedGSheetSections,
        isGoogleSheetAuthenticated: action.payload.isGoogleSheetAuthenticated,
        clickedActiveComponentType: null,
        layout: documentPayload.layout,
        components: documentPayload.components,
        signers: documentPayload.signers,
        // reset below data
        videoKycUrl: "",
        sharedUsersSender: [],
        lastEmailSentAt: documentPayload.lastEmailSentAt,
        pdfFormFields: documentPayload.pdfFormFields,
        isFillablePDF: documentPayload.isFillablePDF,
        isDynamicPDF: documentPayload.isDynamicPDF,
      };
    }
    case "UPDATE_HOVERED_DOCUMENT_SECTION_ID": {
      const { sectionID, updateAfterSection } = action.payload;
      let newActiveSecId = sectionID;
      if (updateAfterSection) {
        if (state.hoveredActiveComponentId === sectionID) {
          newActiveSecId = null;
        } else {
          newActiveSecId = state.hoveredActiveComponentId;
        }
      }
      return {
        ...state,
        hoveredActiveComponentId: newActiveSecId,
      };
    }
    case "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID": {
      const {
        preventClickedComponentIdUpdate,
        clickedActiveComponentId,
        clickedActiveComponentType,
      } = action.payload;
      let coverpagePane = state.coverpageThemeActionLabel;
      // TO DO :: Need to handle the "activeComponentMeta" update for every components
      if (
        coverpagePane === "ApplyTableFormula" &&
        clickedActiveComponentType !== "Table"
      ) {
        coverpagePane = "";
      }
      if (
        clickedActiveComponentId &&
        !state.preventClickedComponentIdUpdate &&
        clickedActiveComponentType !== "Table" &&
        state.clickedActiveComponentType === "Table" &&
        state.activeComponentMeta &&
        Object.keys(state.activeComponentMeta).length > 0
      ) {
        return {
          ...state,
          clickedActiveComponentId,
          preventClickedComponentIdUpdate,
          clickedActiveComponentType,
          activeComponentMeta: {},
          coverpageThemeActionLabel: coverpagePane,
        };
      }
      return {
        ...state,
        coverpageThemeActionLabel: coverpagePane,
        clickedActiveComponentId,
        preventClickedComponentIdUpdate,
        clickedActiveComponentType,
      };
    }
    case "DEACTIVATE_COMPONENT_IF_ACTIVE": {
      const { clickedActiveComponentId } = action.payload;
      if (state.clickedActiveComponentId === clickedActiveComponentId) {
        return {
          ...state,
          clickedActiveComponentId: null,
          preventClickedComponentIdUpdate: true,
          clickedActiveComponentType: null,
        };
      }
      return state;
    }

    case "PREVENT_EDITOR_TO_DEACTIVATE": {
      return {
        ...state,
        preventClickedComponentIdUpdate: action.payload,
      };
    }
    case "HANDLE_CUSTOM_COLOR_DROPDOWN_OPEN": {
      return {
        ...state,
        preventClickedComponentIdUpdate:
          action.payload.preventClickedComponentIdUpdate,
        customColorDropdownStatus: action.payload.status,
      };
    }
    case "PREVENT_COMPONENT_TO_DEACTIVATE": {
      return {
        ...state,
        preventClickedComponentIdUpdate: action.payload,
        preventEditorFocusOnDrag: action.payload,
      };
    }
    case "MAKE_ACTIVE_EDITOR": {
      const { sectionID, flag } = action.payload;
      return {
        ...state,
        clickedActiveComponentId: sectionID,
        hoveredActiveComponentId: sectionID,
        preventClickedComponentIdUpdate: flag,
      };
    }
    case "UPDATE_SEND_FOR_SIGNATURE_BUTTON_STATUS": {
      const { docStatusConfigs, status, stage } = action.payload;
      return {
        ...state,
        document: {
          ...state.document,
          status,
          stage,
        },
        docStatusConfigs,
      };
    }

    case "FETCH_DOC_RECIPIENT_LIST": {
      return {
        ...state,
        docRecipientList: action.payload.data,
        acceptorsList: action.payload.acceptData,
        lastEmailSentAt: action.payload.lastEmailSentAt,
      };
    }
    case "UPDATE_DOC_STAGE_AFTER_ADD_RECIPIENTS": {
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload.stage,
          is_sent_for_signature: action.payload.isSentForSignature,
          document_flow: action.payload.documentFlow,
        },
        // showIframeView: action.payload.showSignIframe
        //   ? !state.showIframeView
        //   : false,
        // signatureIFrameURL: action.payload.iframeUrl,
        signatureEnvelopeID: action.payload.envelopeID,
        docRecipientList: action.payload.docRecipients,
        lastEmailSentAt: action.payload.lastEmailSentAt,
      };
    }
    case "UPDATE_DOC_STAGE_COMPLETED": {
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload.stage,
        },
      };
    }
    case "ADD_COMPONENT_IN_DOCUMENT": {
      const { newSection, newSectionList, headerFooterType } = action.payload;
      const tempNewSectionList = newSectionList.map(sectionID =>
        sectionID === newSection.id
          ? newSection
          : state.content.sections.find(section => section.id === sectionID),
      );
      let tempActiveSectionID = newSection.id;
      let tempClickedActiveComponentId = newSection.id;
      let tempClickedActiveComponentType = newSection.type;
      let tempPreventClickedComponentIdUpdate =
        state.preventClickedComponentIdUpdate;

      if (newSection.type === "EmptyContainer") {
        tempActiveSectionID = state.hoveredActiveComponentId;
        tempClickedActiveComponentId = state.clickedActiveComponentId;
        tempClickedActiveComponentType = state.clickedActiveComponentType;
      }
      // If it is a case of add new Header/Footer then,
      // activate the default text component of header and footer respectively
      if (newSection.type === "HeaderFooter") {
        const { data } = newSection;
        let headerFooterData = [];
        if (headerFooterType === "HEADER") {
          headerFooterData = data.header.data;
        } else if (headerFooterType === "FOOTER") {
          headerFooterData = data.footer.data;
        }
        if (headerFooterData && headerFooterData.length > 0) {
          tempActiveSectionID = headerFooterData[1].id;
          tempClickedActiveComponentId = headerFooterData[1].id;
          tempClickedActiveComponentType = headerFooterData[1].type;
        }
      } else if (newSection.type === "Table") {
        const { data: secData } = newSection;
        if (secData && secData.data && secData.data.length > 0) {
          const [firstRow] = secData.data;
          if (firstRow && firstRow.data && firstRow.data.length > 0) {
            const [firstCellOfFirstRow] = firstRow.data;
            const {
              attributes: { id },
            } = firstCellOfFirstRow;
            if (id) {
              tempClickedActiveComponentId = id;
            }
          }
        }
      }
      if (newSection.type === "Image") {
        tempPreventClickedComponentIdUpdate = undefined;
      }

      return {
        ...state,
        content: {
          ...state.content,
          sections: tempNewSectionList,
        },
        document_order: action.payload.newSectionList,
        hoveredActiveComponentId: tempActiveSectionID,
        clickedActiveComponentId: tempClickedActiveComponentId,
        clickedActiveComponentType: tempClickedActiveComponentType,
        preventClickedComponentIdUpdate: tempPreventClickedComponentIdUpdate,
      };
    }

    case "REMOVE_COMPONENT_IN_DOCUMENT": {
      const { layout, components } = state;
      const newLayout = layout
        .map(row => row.filter(id => id !== action.payload))
        .filter(row => row.length > 0);

      delete components[action.payload];
      return {
        ...state,
        layout: newLayout,
        components,
      };
    }
    // case "UPDATE_DOCUMENT_SECTION_LABEL":
    //   return {
    //     ...state,
    //     content: {
    //       ...state.content,
    //       sections: state.content.sections.map(section => {
    //         if (section.id !== action.payload.sectionID) {
    //           return section;
    //         }
    //         return {
    //           ...section,
    //           label: action.payload.label,
    //         };
    //       }),
    //     },
    //   };
    case "NUKE_QUOTATION_DATA":
      return {
        ...state,
        document: {},
        clauses: [],
        document_order: [],
        docAnalysis: [],
        docApprovalStatus: [],
        docPendingApprovers: [],
        docAllApprovers: [],
        docForm: [],
        components: {},
        componentsCopy: {},
        layout: [[]],
      };
    case "UPDATE_DOC_META": {
      const {
        docID,
        docStatus,
        docIsLocked,
        docStatusConfigs,
        stage,
        revisionNo,
      } = action.payload;
      return {
        ...state,
        document: {
          ...state.document,
          id: docID,
          status: docStatus,
          stage,
          isLocked: docIsLocked,
          revisionNo,
        },
        docStatusConfigs,
      };
    }

    case "TEMP_UPDATE_DOC_META": {
      const { docIsLocked, stage } = action.payload;
      return {
        ...state,
        document: {
          ...state.document,
          stage,
          isLocked: docIsLocked,
        },
      };
    }
    case "REORDER_DOCUMENT_SECTIONLIST": {
      return {
        ...state,
        layout: action.payload.sectionList,
      };
    }
    case "ALL_DYNAMIC_FIELDS":
      return {
        ...state,
        allDynamicFields: action.payload,
      };
    case "DOC_FORM":
      return {
        ...state,
        docForm: action.payload,
      };
    case "FORM_UPDATE_MASTER_DOCUMENT":
      return {
        ...state,
        document: {
          ...state.document,
          fields_used: action.payload,
        },
        docForm: action.payload,
      };
    case "FORM_ALL_UPDATE_MASTER_DOCUMENT":
      return {
        ...state,
        document: {
          ...state.document,
          all_fields_used: action.payload,
        },
        docForm: action.payload,
      };
    case "IS_DOC_FORM_VALID":
      return {
        ...state,
        isDocFormValid: action.payload,
      };
    case "REMOVE_HIGHLIGHT_IN_DOCUMENT":
      return {
        ...state,
        components: {
          ...state.components,
          [action.payload]: {
            ...state.components[action.payload],
            content: {
              ...state.components[action.payload].content,
              highlightedHtml: undefined,
              highlightedContent: undefined,
            },
          },
        },
        hoveredActiveComponentId: action.payload,
      };
    case "SELECTED_DOC_CATEGORY":
      return {
        ...state,
        selectedDocCategory: action.payload,
      };
    case "PATCH_DOCUMENT_DETAILS":
      return {
        ...state,
        document: {
          ...state.document,
          name: action.payload.title,
        },
      };
    case "UPDATE_DOCUMENT_META":
      return {
        ...state,
        document: {
          ...state.document,
          meta_data: action.payload.meta_data,
        },
      };
    case "TEMP_TOGGLE_IFRAME_VIEW": {
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload.stage,
          isLocked: action.payload.isLocked,
          is_sent_for_signature: action.payload.isSentForSignature,
        },
        showIframeView: !state.showIframeView,
        signatureIFrameURL: action.payload.iframeUrl,
        signatureEnvelopeID: action.payload.envelopeID,
      };
    }
    case "TOGGLE_IFRAME_VIEW": {
      const { docStatusConfigs, status, stage, isSentForSignature } =
        action.payload;
      return {
        ...state,
        document: {
          ...state.document,
          status,
          stage,
          is_sent_for_signature: isSentForSignature,
        },
        showIframeView: !state.showIframeView,
        signatureIFrameURL: action.payload.iframeUrl,
        signatureEnvelopeID: action.payload.envelopeID,
        docStatusConfigs,
      };
    }

    case "CANCLE_ESIGNATURE": {
      const { stage } = action.payload;
      return {
        ...state,
        document: {
          ...state.document,
          stage,
          isLocked: false,
          is_sent_for_signature: false,
        },
        showIframeView: false,
        signatureIFrameURL: "",
        signatureEnvelopeID: "",
        docRecipientList: [],
      };
    }
    case "DOC_ACCEPT_AND_SIGN": {
      const { stage } = action.payload;
      return {
        ...state,
        document: {
          ...state.document,
          stage,
        },
      };
    }

    // case "CANCLE_ESIGNATURE": {
    //   const { docStatusConfigs, status, stage } = action.payload;
    //   return {
    //     ...state,
    //     document: {
    //       ...state.document,
    //       status,
    //       stage,
    //       is_sent_for_signature: false,
    //     },
    //     showIframeView: false,
    //     signatureIFrameURL: "",
    //     signatureEnvelopeID: "",
    //     docStatusConfigs,
    //   };
    // }

    case "UPDATE_DOCUMENT_ACTIVE_EDITOR_ID":
      return {
        ...state,
        clickedActiveComponentId: action.payload,
      };

    case "UPDATE_DRAGGED_SECTION": {
      const {
        draggedSection,
        draggedFrom,
        draggedRowIndex,
        draggedColumnIndex,
      } = action.payload;

      if (
        draggedSection === null &&
        draggedFrom === null &&
        draggedRowIndex === null &&
        draggedColumnIndex === null
      ) {
        return {
          ...state,
          draggedSection,
          draggedFrom,
          draggedRowIndex,
          draggedColumnIndex,
          preventEditorFocusOnDrag: true,
        };
      }

      return {
        ...state,
        draggedSection,
        draggedFrom,
        draggedRowIndex,
        draggedColumnIndex,
      };
    }

    case "TOGGLE_DOCUMENT_DIFF_VIEW":
      return {
        ...state,
        showDocumentDiffView: !state.showDocumentDiffView,
      };

    // case "UPDATE_STYLE_COMPONENTS_DOCUMENT_SECTION": {
    //   return {
    //     ...state,
    //     content: {
    //       ...state.content,
    //       sections: state.content.sections.map(section => {
    //         if (section.type !== action.payload.sectionType) {
    //           return section;
    //         }
    //         return action.payload.newSection;
    //       }),
    //     },
    //   };
    // }

    case "UPDATE_DOCUMENT_STATUS":
      if (state.document && state.document.id) {
        return {
          ...state,
          document: {
            ...state.document,
            documentStatus: action.payload,
          },
        };
      }
      return {
        ...state,
      };

    case "UPDATE_DOCUEMNT_TAG":
      if (state.document && state.document.id) {
        return {
          ...state,
          document: {
            ...state.document,
            documentTag: action.payload,
          },
        };
      }
      return {
        ...state,
      };

    case "UPDATE_DOCUMENT_TAG":
      return {
        ...state,
      };
    case "TOGGLE_COVERPAGE_VIEW":
      return { ...state, toggleCoverPageView: action.payload };
    case "NUKE_QUOTETABLE_DATA":
      return {
        ...state,
        document: {
          ...state.document,
          dealTable: null,
          quoteTable: null,
        },
      };
    case "REMOVE_REVIEWER":
      return {
        ...state,
        docRecipientList: state.docRecipientList.filter(
          data => data.user.id !== action.payload.reviewerID,
        ),
      };
    case "UPDATE_EDIT_PERMISSION_FOR_REVIEWER":
      return {
        ...state,
        docRecipientList: state.docRecipientList.map(data => {
          if (data.user.id !== action.payload.reviewerID) {
            return data;
          }
          return {
            ...data,
            is_editable: action.payload.data,
          };
        }),
      };
    case "ADD_DOCUMENT_ACTIVITIES":
      return {
        ...state,
        activities: action.payload.activities,
        hasMoreActivities: action.payload.hasMore,
      };

    case "UPDATE_DOCUMENT_ACTIVITIES":
      return {
        ...state,
        activities: [...state.activities, ...action.payload.activities],
        hasMoreActivities: action.payload.hasMore,
      };

    case "REMOVE_DOCUMENT_ACTIVITIES":
      return {
        ...state,
        activities: [],
        hasMoreActivities: false,
      };

    case "UPDATE_GOOGLE_SHEET_AUTH": {
      return {
        ...state,
        isGoogleSheetAuthenticated: action.payload.isGoogleSheetAuthenticated,
      };
    }
    case "ADD_ACCEPTORS":
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload.stage,
          document_flow: action.payload.documentFlow,
        },
        pendingApprovalRequired: action.payload.pendingApprovalRequired,
        acceptorsList: action.payload.docRecipients,
      };
    case "DOCUMENT_ACCEPTORS_INFORMATION":
      return {
        ...state,
        acceptorsList: action.payload.response,
      };
    case "UPDATE_ACCEPTANCE_STATUS":
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload.doc_stage,
        },
      };

    case "UPDATE_DOC_STAGE":
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload,
        },
      };

    case "UPDATE_DOCUMENT_RECIPIENT_INTERNAL":
      return {
        ...state,
        docRecipientList: state.docRecipientList.map(item => {
          if (item.user.id === action.payload.user_id) {
            return {
              ...item,
              recipient_type: action.payload.recipientType,
            };
          }
          return item;
        }),
        document: {
          ...state.document,
          stage: action.payload.doc_stage,
        },
      };

    // UNDO/REDO STACK REDUCER ACTIONS
    case "ADD_TO_UNDO_STACK":
      return {
        ...state,
        stack: {
          ...state.stack,
          undo:
            state.stack.undo.length >= UNDO_REDO_STACK_LIMIT
              ? [action.payload].concat(state.stack.undo.slice(0, -1)) // Remove the last item and insert the new in the first position
              : [action.payload].concat(state.stack.undo),
        },
      };
    case "UPDATE_UNDO_REDO_STACK_ON_UNDO_ACTION":
    case "UPDATE_UNDO_REDO_STACK_ON_REDO_ACTION":
      return {
        ...state,
        stack: {
          ...state.stack,
          id: uuid.v4(), // pass this as "key" prop to re-render the component when undo/redo is done
          undo: action.payload.undoStack,
          redo: action.payload.redoStack,
        },
      };

    case "REACTION_ON_DOCUMENT_UNDO_ACTION":
    case "REACTION_ON_DOCUMENT_REDO_ACTION":
      return {
        ...state,
        stack: {
          ...state.stack,
          undo: action.payload.undoStack,
          redo: action.payload.redoStack,
        },
      };

    case "UNDO_COMPONENT_UPDATE":
      return {
        ...state,
        layout: action.payload.layout,
        components: action.payload.components,
      };

    case "RESET_UNDO_REDO_STACK":
      return {
        ...state,
        stack: {
          ...state.stack,
          undo: [],
          redo: [],
        },
      };
    case "GENERATE_PERMA_LINK":
      return {
        ...state,
        document: {
          ...state.document,
          doc_perma_link: action.payload.url,
        },
      };
    case "GET_PERMA_LINK":
      return {
        ...state,
        document: {
          ...state.document,
          doc_perma_link: action.payload.data.url,
        },
      };
    case "DELETE_PERMA_LINK":
      return {
        ...state,
        document: {
          ...state.document,
          doc_perma_link: "",
        },
      };
    case "GENERATE_SNAP_LINK":
      return {
        ...state,
        document: {
          ...state.document,
          doc_snap_link: action.payload.url,
          doc_snap_link_created_at: action.payload.created_at,
        },
      };
    case "GET_SNAP_LINK":
      return {
        ...state,
        document: {
          ...state.document,
          doc_snap_link: action.payload.data.url,
          doc_snap_link_created_at: action.payload.data.created_at,
        },
      };
    case "DELETE_SNAP_LINK":
      return {
        ...state,
        document: {
          ...state.document,
          doc_snap_link: "",
          doc_snap_link_created_at: "",
        },
      };
    case "ADD_DOCUMENT_COMPONENT": {
      const { components: oldComponents } = state;
      let { document } = state;
      const {
        newComponent,
        headerFooterType,
        dbRowIndex,
        dbColIndex,
        shouldNotActivateComponent,
      } = action.payload;
      const components = {
        ...oldComponents,
        [newComponent.id]: {
          content: newComponent,
          dbRowIndex,
          dbColIndex,
        },
      };

      let activeComponentMeta = {
        rowIndex: dbRowIndex,
        colIndex: dbColIndex,
        blockType: "BODY",
        itemType: "doc-component",
        componentId: newComponent.id,
        componentType: newComponent.type,
      };

      let tempActiveSectionID = newComponent.id;
      let tempClickedActiveComponentId = newComponent.id;
      let tempClickedActiveComponentType = newComponent.type;
      let tempPreventClickedComponentIdUpdate =
        state.preventClickedComponentIdUpdate;

      // If it is a case of add new Header/Footer then,
      // activate the default text component of header and footer respectively
      if (newComponent.type === "HeaderFooter") {
        const { data } = newComponent;
        let headerFooterData = [];
        if (headerFooterType === "HEADER") {
          activeComponentMeta.blockType = "HEADER";
          activeComponentMeta.itemType = "HEADER";
          activeComponentMeta.headerId = newComponent.id;
          if (
            data.header &&
            data.header.components &&
            Object.keys(data.header.components)
          ) {
            headerFooterData =
              data.header.components[Object.keys(data.header.components)[0]];
          }
        } else if (headerFooterType === "FOOTER") {
          activeComponentMeta.blockType = "FOOTER";
          activeComponentMeta.itemType = "FOOTER";
          activeComponentMeta.footerId = newComponent.id;
          if (
            data.footer &&
            data.footer.components &&
            Object.keys(data.footer.components)
          ) {
            headerFooterData =
              data.footer.components[Object.keys(data.footer.components)[0]];
          }
        }
        if (headerFooterData && headerFooterData.content) {
          tempActiveSectionID = headerFooterData.content.id;
          tempClickedActiveComponentId = headerFooterData.content.id;
          tempClickedActiveComponentType = headerFooterData.content.type;
          activeComponentMeta.componentId = headerFooterData.content.id;
          activeComponentMeta.componentType = headerFooterData.content.type;
        }
      } else if (newComponent.type === "Table") {
        const { data: secData } = newComponent;
        activeComponentMeta.tableId = newComponent.id;
        if (secData && secData.data && secData.data.length > 0) {
          const [firstRow] = secData.data;
          if (firstRow && firstRow.data && firstRow.data.length > 0) {
            const [firstCellOfFirstRow] = firstRow.data;
            const {
              attributes: { id },
            } = firstCellOfFirstRow;
            if (id) {
              tempClickedActiveComponentId = id;
              activeComponentMeta.tableRowId = 0;
              activeComponentMeta.tableColId = 0;
              activeComponentMeta.tableCellId = id;
              activeComponentMeta.tableCellEditMode = true;
            }
          }
        }
      }
      if (newComponent.type === "Image") {
        tempPreventClickedComponentIdUpdate = undefined;
      }
      if (newComponent.type === "Signature") {
        document = {
          ...document,
          signatories: [
            ...document.signatories,
            {
              component_id: newComponent.id,
              signers: newComponent.data,
            },
          ],
        };
        tempPreventClickedComponentIdUpdate = undefined;
      }

      if (shouldNotActivateComponent) {
        tempActiveSectionID = undefined;
        tempClickedActiveComponentId = undefined;
        tempClickedActiveComponentType = undefined;
        activeComponentMeta = {};
      }

      return {
        ...state,
        document,
        layout: action.payload.layout,
        components,
        activeComponentMeta,
        hoveredActiveComponentId: tempActiveSectionID,
        clickedActiveComponentId: tempClickedActiveComponentId,
        clickedActiveComponentType: tempClickedActiveComponentType,
        preventClickedComponentIdUpdate: tempPreventClickedComponentIdUpdate,
      };
    }
    case "DELETE_DOCUMENT_COMPONENT": {
      const {
        layout,
        components: currentComponents,
        document: { signatories },
      } = state;

      const newLayout = layout
        .map(row => row.filter(id => id !== action.payload))
        .filter(row => row.length > 0);
      const newSignatories = signatories.filter(
        signer => signer.component_id !== action.payload,
      );

      const components = { ...currentComponents };
      delete components[action.payload];
      return {
        ...state,
        layout: newLayout,
        components,
        document: {
          ...state.document,
          signatories: newSignatories,
        },
      };
    }
    case "UPDATE_COMPONENTS_DB_ROW_COL_INDEXES": {
      const { components } = state;
      // Updating the dbRowIndex and dbColIndex of all components
      if (
        Array.isArray(action.payload.newComponents) &&
        action.payload.newComponents.length > 0
      ) {
        action.payload.newComponents.forEach(newCmps => {
          if (Array.isArray(newCmps) && newCmps.length > 0) {
            newCmps.forEach(newCmp => {
              if (components[newCmp.component_id]) {
                components[newCmp.component_id] = {
                  content: { ...components[newCmp.component_id].content },
                  dbRowIndex: newCmp.drow,
                  dbColIndex: newCmp.dcol,
                };
              }
            });
          }
        });
      }
      return {
        ...state,
        components,
      };
    }

    case "UPDATE_DOCUMENT_COMPONENT": {
      const { component, newlyAddedComponent } = action.payload;
      const {
        components: currentComponents,
        activeComponentMeta: oldActiveComponentMeta,
      } = state;

      const components = {
        ...currentComponents,
        [component.id]: {
          ...currentComponents[component.id],
          content: component,
        },
      };

      let newActiveComponentMeta = {
        ...oldActiveComponentMeta,
      };
      if (component) {
        let tempHoveredActiveComponentId = state.hoveredActiveComponentId;
        let tempClickedActiveComponentId = state.clickedActiveComponentId;
        let tempClickedActiveComponentType = state.clickedActiveComponentType;
        let tempPreventClickedComponentIdUpdate =
          state.preventClickedComponentIdUpdate;
        /**
         * In CoverPage and Header/Footer adding a new component behaves like update the component, so need to handle this,
         * If there is a case of add new component then, update the new component's id as "clickedActiveComponentId" &
         * in a Table case need to update the first cell's id as a "clickedActiveComponentId"
         */
        if (newlyAddedComponent) {
          newActiveComponentMeta = {
            colIndex: components[component.id].dbColIndex,
            rowIndex: components[component.id].dbRowIndex,
            blockType: "BODY",
            itemType: "doc-component",
            componentId: newlyAddedComponent.id,
            componentType: newlyAddedComponent.type,
          };
          if (newlyAddedComponent.blockType === "COVERPAGE") {
            newActiveComponentMeta.coverpageId = component.id;
            newActiveComponentMeta.blockType = "COVERPAGE";
            newActiveComponentMeta.itemType = "COVERPAGE";
          } else if (newlyAddedComponent.blockType === "HEADER") {
            newActiveComponentMeta.headerId = component.id;
            newActiveComponentMeta.blockType = "HEADER";
            newActiveComponentMeta.itemType = "HEADER";
          } else if (newlyAddedComponent.blockType === "FOOTER") {
            newActiveComponentMeta.footerId = component.id;
            newActiveComponentMeta.blockType = "FOOTER";
            newActiveComponentMeta.itemType = "FOOTER";
          }

          tempHoveredActiveComponentId = newlyAddedComponent.id;
          tempClickedActiveComponentId = newlyAddedComponent.id;
          tempClickedActiveComponentType = newlyAddedComponent.type;
          if (newlyAddedComponent.type === "Table") {
            const { data: secData } = newlyAddedComponent;
            newActiveComponentMeta.tableId = newlyAddedComponent.id;
            if (secData && secData.data && secData.data.length > 0) {
              const [firstRow] = secData.data;
              if (firstRow && firstRow.data && firstRow.data.length > 0) {
                const [firstCellOfFirstRow] = firstRow.data;
                const {
                  attributes: { id },
                } = firstCellOfFirstRow;
                if (id) {
                  tempClickedActiveComponentId = id;
                  newActiveComponentMeta.tableRowId = 0;
                  newActiveComponentMeta.tableColId = 0;
                  newActiveComponentMeta.tableCellId = id;
                  newActiveComponentMeta.tableCellEditMode = true;
                }
              }
            }
          } else if (newlyAddedComponent.type === "Image") {
            tempPreventClickedComponentIdUpdate = undefined;
          }
        }
        return {
          ...state,
          components,
          activeComponentMeta: newActiveComponentMeta,
          hoveredActiveComponentId: tempHoveredActiveComponentId,
          clickedActiveComponentId: tempClickedActiveComponentId,
          clickedActiveComponentType: tempClickedActiveComponentType,
          preventClickedComponentIdUpdate: tempPreventClickedComponentIdUpdate,
        };
      }
      return state;
    }

    case "TOGGLE_COMPONENT_LOCK_UNLOCK": {
      const { component } = action.payload;
      const { components } = state;
      components[component.id] = {
        ...components[component.id],
        content: component,
      };
      return {
        ...state,
        components,
        preventClickedComponentIdUpdate: false,
      };
    }
    case "UPDATE_OUTLINE_LABEL": {
      const { component } = action.payload;
      const { components } = state;
      components[component.id] = {
        ...components[component.id],
        content: component,
      };
      return {
        ...state,
        components,
      };
    }

    case "COVERPAGE_THEME_ACTION":
      return {
        ...state,
        coverpageThemeActionLabel: action.payload,
      };
    case "INIT_SHARED_PERMA_DOCUMENT_DATA":
      return {
        ...state,
        document: {
          ...state.document,
          stage: action.payload.docStage,
          is_sent_for_signature: action.payload.isSentForSignature,
          name: action.payload.docName,
        },
      };
    case "FETCH_TEMPLATE_DETAILS": {
      const {
        isPdfDocument,
        isFillablePDF,
        pdfFormFields,
        isDynamicPDF,
        pdfUrl,
        template,
        signatories,
        signatoriesV2,
      } = action.payload;
      return {
        ...state,
        layout: action.payload.documentData.layout,
        components: action.payload.documentData.components,
        isFillablePDF,
        pdfFormFields,
        isDynamicPDF,
        document: {
          image_base_url: action.payload.documentData.image_base_url,
          signatories,
          signatoriesV2,
          meta_data: action.payload.documentData.meta_data || {},
          isPdfDocument,
          pdfUrl,
          id: template.id,
        },
      };
    }
    case "UPDATE_TEMPLATE_SECTION_WITH_DYNAMIC_FIELD": {
      const { component } = action.payload;
      return {
        ...state,
        components: {
          ...state.components,
          [component.id]: {
            ...state.components[component.id],
            content: component,
          },
        },
      };
    }
    case "UPDATE_COMPONENT_META_IN_TOOLBAR": {
      return {
        ...state,
        activeComponentMeta: action.payload.componentMeta || {},
      };
    }

    case "UPDATE_DOC_SAVE_INDICATOR":
      return {
        ...state,
        docSaveIndicator: action.payload,
      };
    case "UPDATE_USED_FORM_FIELD":
      return {
        ...state,
        document: {
          ...state.document,
          fields_used: action.payload,
        },
        docForm: action.payload,
      };
    case "ALL_UPDATE_USED_FORM_FIELD":
      return {
        ...state,
        document: {
          ...state.document,
          all_fields_used: action.payload,
        },
        docForm: action.payload,
      };
    case "UPDATE_DOC_SIGNATORIES":
      return {
        ...state,
        document: {
          ...state.document,
          signatories: action.payload.updatedSignatories,
        },
      };
    case "UPDATE_STATUS_FORM_FIELD":
      return {
        ...state,
        docForm: action.payload,
      };

    // SUPPORT ADDITION OF BLOCKS INTO PDF DOCUMENT
    case "REACTION_ON_ADDING_ESIGN_BLOCK": {
      const { components } = state;
      let { document } = state;
      const updatedComponents = {
        ...components,
        [action.payload.res[0].component_id]: {
          content: { ...action.payload.content },
        },
      };
      const temp = state.document.signatories ? state.document.signatories : "";
      const tempSigners =
        temp &&
        temp.filter(
          data => data.component_id !== action.payload.res[0].component_id,
        );
      document = {
        ...document,
        signatories: [...tempSigners, ...action.payload.res],
      };
      return {
        ...state,
        components: updatedComponents,
        document,
      };
    }

    case "AUTH_STRIPE":
      return {
        ...state,
        stripePaymentDetails: action.payload,
      };
    case "ADD_STRIPE_SESSION_ID":
      return {
        ...state,
        stripeButtonSessionId: action.payload,
      };
    case "ADD_STRIPE_PAYMENT_DETAILS":
      return {
        ...state,
        stripePaymentButtonDetails: action.payload,
      };
    case "STRIPE_PAYMENT_UPDATE":
      return {
        ...state,
        document: {
          ...state.document,
          isLocked: true,
          paymentStatus: action.payload,
        },
      };
    case "STRIPE_BUTTON_DETAILS":
      return {
        ...state,
        stripePaymentButtonDetails: action.payload,
      };
    case "DEACTIVATE_STRIPE_USER":
      return {
        ...state,
        stripePaymentDetails: null,
        stripeFlag: true,
      };
    case "STRIPE_AUTH_FLAG":
      return {
        ...state,
        stripeFlag: false,
      };
    case "FORCE_UPDATE_EDITOR_SECTION_ID":
      return {
        ...state,
        forceUpdateEditorSectionId: action.payload,
      };

    case "FORCE_RERENDER_WHEN_CLAUSE_OPTIONS_UPDATE":
      return {
        ...state,
        forceRerenderClauseSection: action.payload,
      };

    case "FORCE_INIT_EDITOR_STATE":
      return {
        ...state,
        forceInitEditorState: action.payload.forceInitEditorState,
        clickedActiveComponentId: action.payload.clickedActiveComponentId,
        preventClickedComponentIdUpdate:
          action.payload.preventClickedComponentIdUpdate,
        clickedActiveComponentType: action.payload.clickedActiveComponentType,
      };

    // case "FORCE_UPDATE_COMPONENT_EDITOR_STATE": {
    //   const { componentMeta, editorState, forceInitEditorState } =
    //     action.payload;
    //   if (componentMeta) {
    //     const { components } = state;

    //     if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.HTML) {
    //       set(
    //         components[componentMeta.componentId],
    //         "content.editorState",
    //         editorState,
    //       );

    //       return {
    //         ...state,
    //         components,
    //         forceInitEditorState,
    //         activeComponentMeta: componentMeta,
    //       };
    //     }
    //   }
    //   return state;
    // }

    case "UPDATE_COMPONENT_EDITOR_STATE": {
      const { componentMeta, editorState } = action.payload;
      const { components } = state;

      if (componentMeta) {
        const { componentId, blockType } = componentMeta;
        if (blockType === DOCUMENT_BLOCKS.BODY) {
          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.HTML) {
            set(
              components[componentId],
              "content.data",
              editorState.getCurrentContent(),
            );
            if (!components[componentId].content.label) {
              const firstBlock = editorState
                .getCurrentContent()
                .getFirstBlock();
              set(
                components[componentId],
                "content.header",
                firstBlock.getText().trim(),
              );
            }
            return {
              ...state,
              components,
            };
          }
          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.TABLE) {
            const { tableRowId, tableColId } = componentMeta;

            const { data: tableData } = components[componentId].content;

            if (
              tableData.data[tableRowId] &&
              tableData.data[tableRowId].data &&
              tableData.data[tableRowId].data[tableColId] &&
              componentMeta.tableCellId ===
                tableData.data[tableRowId].data[tableColId].attributes.id
            ) {
              const cellData = tableData.data[tableRowId].data[tableColId].data;
              if (typeof cellData === "string") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              } else if (typeof cellData === "object") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              }

              components[componentId] = {
                ...components[componentId],
                content: {
                  ...components[componentId].content,
                  data: { ...tableData },
                },
              };
            }
            return {
              ...state,
              components,
            };
          }
        } else if (
          blockType === DOCUMENT_BLOCKS.HEADER &&
          componentMeta.headerId
        ) {
          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.HTML) {
            set(
              components[componentMeta.headerId].content.data.header.components[
                componentId
              ],
              "content.data",
              editorState.getCurrentContent(),
            );

            return {
              ...state,
              components,
            };
          }

          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.TABLE) {
            const { tableRowId, tableColId } = componentMeta;

            const { data: tableData } =
              components[componentMeta.headerId].content.data.header.components[
                componentId
              ].content;

            if (
              tableData.data[tableRowId] &&
              tableData.data[tableRowId].data &&
              tableData.data[tableRowId].data[tableColId] &&
              componentMeta.tableCellId ===
                tableData.data[tableRowId].data[tableColId].attributes.id
            ) {
              const cellData = tableData.data[tableRowId].data[tableColId].data;
              if (typeof cellData === "string") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              } else if (typeof cellData === "object") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              }
              components[componentMeta.headerId].content.data.header.components[
                componentId
              ] = {
                ...components[componentMeta.headerId].content.data.header
                  .components[componentId],
                content: {
                  ...components[componentMeta.headerId].content.data.header
                    .components[componentId].content,
                  data: { ...tableData },
                },
              };
            }
            return {
              ...state,
              components,
            };
          }
        } else if (
          blockType === DOCUMENT_BLOCKS.FOOTER &&
          componentMeta.footerId
        ) {
          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.HTML) {
            set(
              components[componentMeta.footerId].content.data.footer.components[
                componentId
              ],
              "content.data",
              editorState.getCurrentContent(),
            );
            return {
              ...state,
              components,
            };
          }

          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.TABLE) {
            const { tableRowId, tableColId } = componentMeta;

            const { data: tableData } =
              components[componentMeta.footerId].content.data.footer.components[
                componentId
              ].content;

            if (
              tableData.data[tableRowId] &&
              tableData.data[tableRowId].data &&
              tableData.data[tableRowId].data[tableColId] &&
              componentMeta.tableCellId ===
                tableData.data[tableRowId].data[tableColId].attributes.id
            ) {
              const cellData = tableData.data[tableRowId].data[tableColId].data;
              if (typeof cellData === "string") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              } else if (typeof cellData === "object") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              }

              components[componentMeta.footerId].content.data.footer.components[
                componentId
              ] = {
                ...components[componentMeta.footerId].content.data.footer
                  .components[componentId],
                content: {
                  ...components[componentMeta.footerId].content.data.footer
                    .components[componentId].content,
                  data: { ...tableData },
                },
              };
            }
            return {
              ...state,
              components,
            };
          }
        } else if (
          blockType === DOCUMENT_BLOCKS.COVERPAGE &&
          componentMeta.coverpageId
        ) {
          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.HTML) {
            set(
              components[componentMeta.coverpageId].content.data.components[
                componentId
              ],
              "content.data",
              editorState.getCurrentContent(),
            );
            return {
              ...state,
              components,
            };
          }
          if (componentMeta.componentType === DOCUMENT_COMPONENT_TYPES.TABLE) {
            const { tableRowId, tableColId } = componentMeta;

            const { data: tableData } =
              components[componentMeta.coverpageId].content.data.components[
                componentId
              ].content;

            if (
              tableData.data[tableRowId] &&
              tableData.data[tableRowId].data &&
              tableData.data[tableRowId].data[tableColId] &&
              componentMeta.tableCellId ===
                tableData.data[tableRowId].data[tableColId].attributes.id
            ) {
              const cellData = tableData.data[tableRowId].data[tableColId].data;
              if (typeof cellData === "string") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              } else if (typeof cellData === "object") {
                tableData.data[tableRowId].data[tableColId].data = {
                  data: editorState.getCurrentContent(),
                };
              }

              components[componentMeta.coverpageId].content.data.components[
                componentId
              ] = {
                ...components[componentMeta.coverpageId].content.data
                  .components[componentId],
                content: {
                  ...components[componentMeta.coverpageId].content.data
                    .components[componentId].content,
                  data: { ...tableData },
                },
              };
            }
            return {
              ...state,
              components,
            };
          }
        }
      }
      return state;
    }

    case "UPDATE_LAYOUT_INSIDE_COMPONENT": {
      const { componentID, layout, draggedTo } = action.payload;
      const { components } = state;
      if (draggedTo === "CoverPage") {
        set(components[componentID], "content.data.layout", layout);
      } else if (draggedTo === "footer") {
        set(components[componentID], "content.data.footer.layout", layout);
      } else if (draggedTo === "header") {
        set(components[componentID], "content.data.header.layout", layout);
      }
      return {
        ...state,
        components,
      };
    }

    case "UPDATE_SHARED_USERS": {
      const { sharedUsersSender } = action.payload;
      return {
        ...state,
        sharedUsersSender,
      };
    }
    case "UPDATE_EMAIL_MESSAGE": {
      const { emailMessage } = action.payload;
      return {
        ...state,
        emailMessage,
      };
    }

    case "COPY_COMPONENTS_QUICKREVIEW":
      return {
        ...state,
        componentsCopy: { ...state.components },
      };

    case "UPDATE_COMPONENTS_QUICKREVIEW":
      return {
        ...state,
        components: {
          ...state.componentsCopy,
          ...action.payload.newComponents,
        },
      };

    case "REVERSE_UPDATE_COMPONENTS_QUICKREVIEW":
      return {
        ...state,
        components: state.componentsCopy,
      };

    case "UPDATE_VIDEO_URL": {
      const { videoKycUrl } = action.payload;
      return {
        ...state,
        videoKycUrl,
      };
    }
    case "UPDATE_ACTIVE_COMPONENT_META": {
      const {
        activeComponentMeta,
        hoveredActiveComponentId,
        clickedActiveComponentId,
        clickedActiveComponentType,
        preventClickedComponentIdUpdate,
      } = action.payload;
      return {
        ...state,
        activeComponentMeta: activeComponentMeta || {},
        hoveredActiveComponentId: hoveredActiveComponentId || null,
        clickedActiveComponentId: clickedActiveComponentId || null,
        clickedActiveComponentType: clickedActiveComponentType || null,
        preventClickedComponentIdUpdate:
          preventClickedComponentIdUpdate || true,
      };
    }

    case "RESEND_EMAIL_REIPIENT": {
      return {
        ...state,
        lastEmailSentAt: action.payload.last_email_sent_at,
      };
    }
    case "GET_MASTER_DOC":
    case "GENERATE_MASTER_DOC":
      return {
        ...state,
        document: {
          ...state.document,
          docType: "master_form",
          isLocked: true,
          masterDoc: action.payload,
        },
      };
    case "DISABLE_MASTER_DOC":
      return {
        ...state,
        document: {
          ...state.document,
          masterDoc: null,
        },
      };
    // case "UPDATE_EDITOR_STATE_IN_SECTION_FOR_CLAUSE_OPTIONS": {
    //   const { componentMeta, editorState } = action.payload;
    //   const { components } = state;
    //   if (componentMeta) {
    //     const { componentId, blockType } = componentMeta;
    //     if (blockType === "Body" || blockType === DOCUMENT_BLOCKS.BODY) {
    //       if (componentMeta.itemType === DOCUMENT_COMPONENT_TYPES.HTML) {
    //         set(components[componentId], "content.editorState", editorState);
    //         return {
    //           ...state,
    //           components,
    //         };
    //       }
    //     }
    //   }
    //   return state;
    // }
    case "RECALCULATE_PAGE_BREAKS": {
      return {
        ...state,
        reCalculatePageBreaks: !state.reCalculatePageBreaks,
      };
    }
    case "UPDATE_CURRENT_ZOOM": {
      const { currentZoom } = action.payload;
      return {
        ...state,
        currentZoom,
      };
    }
    case "UPDATE_TABLE_SELECTION_TYPE":
      return {
        ...state,
        tableSelectionType: action.payload,
      };

    case "GET_DOCUMENT_FORWARDING_SETTINGS": {
      return {
        ...state,
        document: {
          ...state.document,
          documentSettings: action.payload.res,
        },
      };
    }

    case "UPDATE_DOCUMENT_FORWARDING_SETTINGS":
      return {
        ...state,
        document: {
          ...state.document,
          documentSettings: [action.payload.res],
        },
      };

    case "FETCH_DOC_SIGNATORIES_V2":
      return {
        ...state,
        document: {
          ...state.document,
          signatoriesV2: action.payload.signatories,
        },
      };

    case "CREATE_DOC_SIGNER_IDENTITY":
      return {
        ...state,
        document: {
          ...state.document,
          signatoriesV2: [
            ...state.document.signatoriesV2,
            { ...action.payload.signer },
          ],
        },
      };

    case "UPDATE_DOC_SIGNATORIES_V2":
      // add new tag + update the tags for the signer_identity_id
      return {
        ...state,
        draggedSection: "",
        document: {
          ...state.document,
          signatoriesV2: state.document.signatoriesV2.map(signatory => {
            const { signer_identity_id } = signatory;
            if (signer_identity_id in action.payload.signerIdentityTags) {
              const newUpdatedTags =
                action.payload.signerIdentityTags[signer_identity_id];
              // updated tags , not updatedtags, new tags
              return {
                ...signatory,
                tags: getCombinedTags(signatory.tags, newUpdatedTags),
              };
            }

            return signatory;
          }),
        },
      };

    case "UPDATE_DOC_SIGNER_IDENTITY":
      return {
        ...state,
        document: {
          ...state.document,
          signatoriesV2: state.document.signatoriesV2.map(signatory => {
            if (action.payload.signer.id === signatory.signer_identity_id) {
              return {
                ...signatory,
                first_name: action.payload.signer.first_name,
                last_name: action.payload.signer.last_name,
                signer_email: action.payload.signer.signer_email,
              };
            }
            return signatory;
          }),
        },
      };

    case "DELETE_DOC_SIGNER_IDENTITY":
      return {
        ...state,
        document: {
          ...state.document,
          signatoriesV2: state.document.signatoriesV2.filter(
            signatory =>
              signatory.signer_identity_id !== action.payload.signerID,
          ),
        },
      };

    case "BULK_DELETE_DOCUMENT_COMPONENTS":
      return {
        ...state,
        layout: state.layout
          .map(row => row.filter(id => !action.payload.componentIdSet.has(id)))
          .filter(row => row.length > 0),
        components: Object.keys(state.components)
          .filter(id => !action.payload.componentIdSet.has(id))
          .reduce((acc, cid) => ({ ...acc, [cid]: state.components[cid] }), {}),
      };

    case "DELETE_SIGNATORY_V2_TAGS":
      return {
        ...state,
        document: {
          ...state.document,
          signatoriesV2: state.document.signatoriesV2.map(signatory => ({
            ...signatory,
            tags: signatory.tags.filter(
              tag =>
                !(
                  tag.component_id === action.payload.component_id &&
                  action.payload.ids.includes(tag.id)
                ),
            ),
          })),
        },
      };

    case "ADD_PDF_SIGNATURE_COMPONENT":
      return {
        ...state,
        components: {
          ...state.components,
          [action.payload.componentID]: action.payload.component,
        },
      };
    case "UPDATE_TABLE_FIELDS_ROWS": {
      const { tableId, rows } = action.payload;
      const { tables } = state;
      if (Array.isArray(tables)) {
        const updatedTables = tables.map(table => {
          if (table.table_id === tableId) return { ...table, table_rows: rows };
          return table;
        });
        return {
          ...state,
          tables: updatedTables,
        };
      }
      return state;
    }

    case "UPDATE_TABLE_API_FIELD": {
      const {
        field: { id, tables, value },
        tableAPIType,
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          return { ...field, tables, value };
        }
        return field;
      });

      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...state.tables, { ...tables[value[tableAPIType]] }],
      };
    }

    case "UPDATE_UNLINKED_TABLE_API_CELL_DATA": {
      const { tableFieldId, rowId, cellId, cellData } = action.payload;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableFieldId) {
          const updatedTableRows = table.table_rows.map(row => {
            if (row.row_id === rowId) {
              return {
                ...row,
                row_data: {
                  ...row.row_data,
                  [cellId]: cellData,
                },
              };
            }
            return row;
          });

          return {
            ...table,
            table_rows: updatedTableRows,
          };
        }
        return table;
      });
      return {
        ...state,
        tables: updatedTables,
      };
    }
    case "UPDATE_UNLINKED_TABLE_API_COL_DATA": {
      const { tableFieldId, cellId, cellData } = action.payload;
      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableFieldId) {
          return {
            ...table,
            table_schema: {
              ...table.table_schema,
              label_map: {
                ...table.table_schema.label_map,
                [cellId]: cellData,
              },
            },
          };
        }
        return table;
      });
      return {
        ...state,
        tables: updatedTables,
      };
    }
    case "UPDATE_TABLE_API_TYPE": {
      const {
        tableId,
        tableType,
        clauseField: { id, tables, value },
        componentId,
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
        components,
      } = state;
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          tables[tableId].table_type = tableType;
          return { ...field, tables, value };
        }
        return field;
      });

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableId) {
          table.table_type = tableType;
        }
        return table;
      });

      const section = components[componentId].content;
      components[componentId] = {
        ...components[componentId],
        content: {
          ...section,
          data: {
            ...section.data,
            attributes: {
              ...section.data.attributes,
              isUnlinkedTableDocument: true,
            },
          },
        },
      };

      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: updatedTables,
        components,
      };
    }

    case "TABLE_ADD_ROW": {
      const {
        rowData,
        tableId,
        clauseField: { id, tables: tablesInField, value },
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;
      let { insertRowAfter } = action.payload;
      insertRowAfter = insertRowAfter - 1 < 0 ? 0 : insertRowAfter;

      const tableData = state.tables.find(table => table.table_id === tableId);
      const { table_rows: tableRows } = tableData;

      const newTableRows = tableRows
        .slice(0, insertRowAfter)
        .concat(rowData, tableRows.slice(insertRowAfter, tableRows.length));
      tableData.table_rows = newTableRows;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableData.table_id) {
          table = tableData;
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          tablesInField[tableId] = { ...tablesInField[tableId], ...tableData };
          return { ...field, tablesInField, value };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "TABLE_ADD_COL": {
      const {
        tableData,
        tableId,
        clauseField: { id, tables, value },
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableData.table_id) {
          table = { ...table, ...tableData };
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          tables[tableId] = { ...tables[tableId], ...tableData };
          return { ...field, tables, value };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "TABLE_DELETE_ROW": {
      const {
        tableId,
        clauseField: { id, tables, value },
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;
      let { deleteRowAt } = action.payload;
      deleteRowAt = deleteRowAt - 1 < 0 ? 0 : deleteRowAt - 1;

      const tableData = state.tables.find(table => table.table_id === tableId);
      const { table_rows: tableRows } = tableData;

      const newTableRows = tableRows
        .slice(0, deleteRowAt)
        .concat(tableRows.slice(deleteRowAt + 1, tableRows.length));
      tableData.table_rows = newTableRows;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableData.table_id) {
          table = tableData;
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          tables[tableId] = { ...tables[tableId], ...tableData };
          return { ...field, tables, value };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "TABLE_DELETE_COL": {
      const {
        tableData,
        tableId,
        clauseField: { id, tables, value },
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableData.table_id) {
          table = { ...table, ...tableData };
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          tables[tableId] = { ...tables[tableId], ...tableData };
          return { ...field, tables, value };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "TABLE_ROW_UPDATE": {
      const {
        rowData,
        tableId,
        updateRowAt,
        clauseField: { id, tables, value },
      } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;
      const currTableData = state.tables.find(
        table => table.table_id === tableId,
      );
      const { table_rows: tableRows } = currTableData;

      const newTableRows = tableRows.map(tableRow => {
        const { row_data: rowDataInTable } = tableRow;
        rowDataInTable[updateRowAt] = rowData;
        return tableRow;
      });
      currTableData.table_rows = newTableRows;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === currTableData.table_id) {
          table = { ...currTableData };
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === id) {
          tables[tableId] = { ...tables[tableId], ...currTableData };
          return { ...field, tables, value };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }

    case "TABLE_REORDER_COLUMN_UPDATE": {
      const { columnOrder, tableId, dynamicFieldId } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableId) {
          table.column_order = columnOrder;
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === dynamicFieldId) {
          field.tables[tableId].column_order = columnOrder;
          return { ...field };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "TABLE_META_UPDATE": {
      const { appendTableMeta, tableId, dynamicFieldId } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableId) {
          table.table_meta = appendTableMeta;
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === dynamicFieldId) {
          field.tables[tableId].table_meta = appendTableMeta;
          return { ...field };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "TABLE_BATCH_CELLS_UPDATE": {
      const { tableId, dynamicFieldId, tableRows } = action.payload;
      const {
        document: { fields_used: fieldsUsed },
      } = state;

      const updatedTables = state.tables.map(table => {
        if (table.table_id === tableId) {
          table.table_rows = tableRows;
        }
        return table;
      });
      const updateFields = fieldsUsed.map(field => {
        if (field.id === dynamicFieldId) {
          field.tables[tableId].table_rows = tableRows;
          return { ...field };
        }
        return field;
      });
      return {
        ...state,
        document: { ...state.document, fields_used: updateFields },
        tables: [...updatedTables],
      };
    }
    case "UPDATE_BLOCKCHAIN_META_DATA": {
      return {
        ...state,
        document: {
          ...state.document,
          blockchainMetaData: action.payload || {},
        },
      };
    }
    case "UPDATE_FORM_DOC_TYPE_TO_EDITOR": {
      return {
        ...state,
        document: {
          ...state.document,
          showForm: false,
          docType: "editor",
        },
      };
    }
    case "SAVE_TEMP_PASTED_IMAGE": {
      return {
        ...state,
        pastedTempImage: action.payload.file,
        pastedImageSectionID: action.payload.sectionID,
      };
    }
    default:
      return state;
  }
};
